module.exports = __webpack_public_path__ + "img/banktransfer.42cea9fa.svg";